import { render } from "./IconEmail.vue?vue&type=template&id=9b60ca40&scoped=true&ts=true"
import script from "./IconEmail.vue?vue&type=script&lang=ts"
export * from "./IconEmail.vue?vue&type=script&lang=ts"

import "./IconEmail.vue?vue&type=style&index=0&id=9b60ca40&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b60ca40"]])

export default __exports__